<template>
  <div>
    <el-button class="button" type="primary" @click="getDefault()"
      >查询</el-button
    >
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <div class="search-left-top">
        <el-form-item label="内容：">
          <el-input v-model="formInline.content"></el-input>
        </el-form-item>
        <el-form-item label="作者：">
          <el-input v-model="formInline.author"></el-input>
        </el-form-item>
        <el-form-item label="来源：">
          <el-input v-model="formInline.source"></el-input>
        </el-form-item>
        <el-form-item label="状态：">
          <el-select v-model="formInline.status">
            <el-option
              v-for="item in status"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </div>
    </el-form>
    <!-- 标题 -->
    <div class="title">
      <div>珍言列表</div>
      <el-button type="primary" @click="add">新增</el-button>
    </div>
    <el-table
      :data="zhenyanData"
      border
      style="width: 100%"
      v-loading="loading"
    >
      <el-table-column prop="id" label="ID" align="center" width="150">
      </el-table-column>
      <el-table-column prop="source" label="来源" align="center" width="150">
      </el-table-column>
      <el-table-column prop="content" label="内容" align="center">
      </el-table-column>
      <el-table-column prop="author" label="作者" align="center" width="150">
      </el-table-column>
      <el-table-column label="操作" align="center" width="400">
        <template slot-scope="scope">
          <el-button type="text" @click="detail(scope.row)">详情</el-button>
          <el-button type="text" @click="edit(scope.row)">编辑</el-button>
          <el-button type="text" @click="del(scope.row)">删除</el-button>
          <el-button
            type="text"
            v-if="scope.row.is_shelf == 1"
            @click="isShelf(scope.row)"
            >下架</el-button
          >
          <el-button
            type="text"
            v-if="scope.row.is_shelf == 0"
            @click="isShelf(scope.row)"
            >上架</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination" v-if="totalPages > 1">
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page="currentPage"
        :page-size="page_size"
        :total="pageTotal"
        @current-change="handlePageChange"
      ></el-pagination>
    </div>

    <!-- 珍言编辑弹出框 -->
    <el-dialog
      :visible.sync="editZhenyanVisible"
      width="50%"
      :close-on-click-modal="false"
      :title="editTitle"
      center
    >
      <el-form ref="ruleForm" :model="zhenyanForm" label-width="180px">
        <el-form-item label="内容：">
          <el-input type="text" v-model="zhenyanForm.content"></el-input>
        </el-form-item>
        <el-form-item label="出处：">
          <el-input type="text" v-model="zhenyanForm.source"></el-input>
        </el-form-item>
        <el-form-item label="作者：">
          <el-input type="text" v-model="zhenyanForm.author"></el-input>
        </el-form-item>
        <el-form-item label="label：">
          <el-input type="text" v-model="zhenyanForm.label"></el-input>
        </el-form-item>
        <el-form-item label="标签：">
          <div
            v-for="(item, i) in zhenyanForm.labels"
            :key="i"
            style="margin-bottom: 10px;display: flex;align-items: center;"
          >
            <el-select v-model="item.type" class="handle-select">
              <el-option
                v-for="(child, index) in bqList"
                :key="index"
                :label="child.label"
                :value="child.value"
              ></el-option>
            </el-select>
            <el-input
              type="text"
              v-model="item.title"
              style="width:200px;margin-left: 10px;margin-right: 10px;"
            ></el-input>
            <el-button type="primary" @click="delBq(i)">删 除</el-button>
          </div>
          <el-button type="primary" @click="addBq">添 加</el-button>
        </el-form-item>
      </el-form>
      <span
        v-if="is_add == true"
        slot="footer"
        class="dialog-footer self-dialog-footer"
      >
        <el-button type="primary" @click="saveEdit('ruleForm')"
          >保 存</el-button
        >
        <el-button type="primary" @click="editZhenyanVisible = false"
          >取 消</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import http from "../../../api/zkApiConfig";
export default {
  data() {
    return {
      id: "",
      is_add: false,
      is_edit: false,
      editZhenyanVisible: false,
      editTitle: "珍言详情页",
      loading: false,
      formInline: {},
      zhenyanForm: {},
      zhenyanData: [],
      //   分页
      currentPage: 1,
      totalPages: 1,
      page_size: 10,
      pageTotal: 10,
      page_index: 10,
      form: {},
      status: [
        {
          value: "1",
          label: "已上架",
        },
        {
          value: "0",
          label: "已下架",
        },
      ],
      // 标签
      labels: "",
      bqList: [
        {
          value: "1",
          label: "书名",
        },
        {
          value: "2",
          label: "书目",
        },
        {
          value: "3",
          label: "作者",
        },
        {
          value: "4",
          label: "科室",
        },
        {
          value: "5",
          label: "医生",
        },
        {
          value: "6",
          label: "出处",
        },
        {
          value: "7",
          label: "疾病",
        },
        {
          value: "9",
          label: "功效",
        },
        {
          value: "10",
          label: "经络",
        },
        {
          value: "11",
          label: "朝代",
        },
        {
          value: "12",
          label: "方剂名",
        },
        {
          value: "13",
          label: "中药名称",
        },
        {
          value: "14",
          label: "经穴名称",
        },
      ],
    };
  },
  mounted() {
    this.getDefault();
  },
  methods: {
    addBq() {
      var newItem = { type: "", title: "" };
      this.zhenyanForm.labels.push(newItem);
    },
    delBq(i) {
      this.zhenyanForm.labels.splice(i, 1);
    },
    getDefault() {
      this.loading = true;
      let params = {
        page: this.currentPage,
        page_size: this.page_size,
        content: this.formInline.content,
        author: this.formInline.author,
        source: this.formInline.source,
        is_shelf: this.formInline.status,
      };
      http.get("/admin/zsk/zy_list", { params: params }).then((res) => {
        if (res.data.status_code == 200) {
          this.zhenyanData = res.data.data.data;
          this.currentPage = Number(res.data.data.current_page);
          this.totalPages = res.data.data.last_page;
          this.pageTotal = this.totalPages * this.page_size;
          this.loading = false;
        }
      });
    },
    // 新增
    add() {
      this.is_add = true;
      this.is_edit = false;
      this.zhenyanForm = {
        labels: [
          {
            type: "",
            title: "",
          },
        ],
      };
      this.editZhenyanVisible = true;
    },
    // 编辑
    edit(row) {
      this.id = row.id;
      this.is_add = true;
      this.is_edit = true;
      this.editZhenyanVisible = true;
      this.getInfo();
    },
    // 详情接口
    getInfo() {
      http.get("/admin/zsk/zy/" + this.id).then((res) => {
        if (res.data.status_code == 200) {
          this.zhenyanForm = res.data.data;
        }
      });
    },
    // 删除
    del(row) {
      let that = this;
      that
        .$confirm("确定要删除吗？", "提示", {
          type: "warning",
        })
        .then(() => {
          http.delete("/admin/zsk/zy/" + row.id).then((res) => {
            if (res.data.status_code == 200) {
              that.getDefault();
              that.$message.success("已删除");
            } else {
              that.$message.error(res.data.msg);
            }
          });
        })
        .catch(() => {});
    },
    // 详情
    detail(row) {
      this.id = row.id;
      this.is_add = false;
      this.editZhenyanVisible = true;
      this.getInfo();
    },
    // 提交
    saveEdit() {
      if (this.is_edit == true) {
        // 标签处理
        let labels = this.zhenyanForm.labels;
        let data = "";
        this.zhenyanForm.labels = "";
        for (let i = 0; i < labels.length; i++) {
          data = labels[i].type + "_" + labels[i].title + ",";
          this.zhenyanForm.labels += data;
        }
        this.zhenyanForm.labels = this.zhenyanForm.labels.substring(
          0,
          this.zhenyanForm.labels.length - 1
        );
        let params = {
          source: this.zhenyanForm.source,
          content: this.zhenyanForm.content,
          author: this.zhenyanForm.author,
          label: this.zhenyanForm.label,
          labels: this.zhenyanForm.labels,
        };
        http.put("/admin/zsk/zy/" + this.id, params).then((res) => {
          if (res.data.status_code == 200) {
            this.$message.success("修改成功");
            this.getDefault();
            this.editZhenyanVisible = false;
          } else {
            this.$message.error(res.data.msg);
          }
        });
      } else {
        // 标签处理
        let labels = this.zhenyanForm.labels;
        let data = "";
        var data1 = "";
        for (let i = 0; i < labels.length; i++) {
          data = labels[i].type + "_" + labels[i].title + ",";
          data1 += data;
        }
        data1 = data1.substring(0, data1.length - 1);
        let params = {
          source: this.zhenyanForm.source,
          content: this.zhenyanForm.content,
          author: this.zhenyanForm.author,
          label: this.zhenyanForm.label,
          labels: data1,
        };
        http.post("/admin/zsk/zy", params).then((res) => {
          if (res.data.status_code == 200) {
            this.$message.success("新增成功");
            this.getDefault();
            this.editZhenyanVisible = false;
          } else {
            this.$message.error(res.data.msg);
          }
        });
      }
    },
    // 时间
    formatDate(time) {
      return new Date(time * 1000).Format("YYYY-MM-DD hh:mm:ss");
    },
    // 上下架
    isShelf(row) {
      let that = this;
      if (row.is_shelf == 1) {
        that
          .$confirm("确定要下架吗？", "提示", {
            type: "warning",
          })
          .then(() => {
            http.put("/admin/zsk/zy/shelf/" + row.id).then((res) => {
              if (res.data.status_code == 200) {
                that.getDefault();
                that.$message.success("已下架");
              } else {
                that.$message.error(res.data.msg);
              }
            });
          })
          .catch(() => {});
      } else {
        //
        that
          .$confirm("确定要上架吗？", "提示", {
            type: "warning",
          })
          .then(() => {
            http.put("/admin/zsk/zy/shelf/" + row.id).then((res) => {
              if (res.data.status_code == 200) {
                that.getDefault();
                that.$message.success("已上架");
              } else {
                that.$message.error(res.data.msg);
              }
            });
          })
          .catch(() => {});
      }
    },
    // 分页导航
    handlePageChange(val) {
      this.currentPage = val;
      this.getDefault();
    },
  },
};
</script>

<style scoped>
.header-tab {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.button {
  height: 40px;
  position: absolute;
  right: 28px;
  z-index: 999;
}
.title {
  width: 100%;
  padding: 10px 0;
  font-size: 22px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
/deep/#tab-1-1 {
  width: 200px !important;
}
/deep/#tab-1-2 {
  width: 200px !important;
}
/deep/.el-tabs__item {
  width: 300px !important;
  text-align: center;
}
/deep/.is-active {
  border-bottom-color: #409eff !important;
}
/deep/.el-table__header {
  width: 100% !important;
}
/deep/.el-table__empty-block {
  width: 100% !important;
}
/deep/.el-table__body {
  width: 100% !important;
}
</style>
